import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { ExperienceProvider } from '@/lib/experience';
import { PlanModalProvider } from './components/ContactModal';
import { Preloader } from './components/Preloader';
import { Cursor } from './components/fx/Cursor';
import { BurstLayer } from './components/fx/Burst';
import { ScrollProgress } from './components/ScrollProgress';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Manifesto } from './components/Manifesto';
import { Ritual } from './components/Ritual';
import { Pricing } from './components/Pricing';
import { Passeio } from './components/Passeio';
import { Gallery } from './components/Gallery';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';

const HomePage = () => (
  <>
    <Preloader />
    <ScrollProgress />
    <Navbar />
    <main id="conteudo">
      <Hero />
      <Marquee />
      <Manifesto />
      <Ritual />
      <Pricing />
      <Passeio />
      <Gallery />
      <FAQ />
      <Contact />
    </main>
    <Footer />
    <FloatingWhatsApp />
    <Cursor />
    <BurstLayer />
  </>
);

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <ExperienceProvider>
        <PlanModalProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
            </Routes>
          </BrowserRouter>
        </PlanModalProvider>
      </ExperienceProvider>
    </MotionConfig>
  );
}

export default App;
